<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('equivalence_information').toUpper() }}</h5>
        <div v-for="(itm,key) in eqData" :key="key">
            <div class="mb-2 d-flex">
                <b-button variant="light"
                          class="border w-40 h-40 mr-2"
                          v-b-toggle="'collapse-'+key">
                    <i class="ri-arrow-down-s-line"></i>
                </b-button>
                <div
                    class="flex-grow-1 bg-light w-40 h-40 border rounded-sm d-flex align-items-center pl-3 font-weight-bold">
                    {{ itm.university+'; '+itm.program+'; '+itm.education_type }}
                </div>
            </div>
            <b-collapse :id="'collapse-'+key">
                <div class="border rounded-sm p-4 mb-4">
                    <b-row>
                        <b-col cols="auto">
                            <b-form-group :label="$t('name')">
                                <div class="label-as-input">
                                    {{itm.name}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('surname')">
                                <div class="label-as-input">
                                    {{itm.surname}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('national_id')">
                                <div class="label-as-input">
                                    {{itm.national_id}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('university')">
                                <div class="label-as-input">
                                    {{itm.university}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('university_id')">
                                <div class="label-as-input">
                                    {{itm.university_id}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('program')">
                                <div class="label-as-input">
                                    {{itm.program}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('program_id')">
                                <div class="label-as-input">
                                    {{itm.program_id}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('mode_of_study')">
                                <div class="label-as-input">
                                    {{itm.education_type}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('country')">
                                <div class="label-as-input">
                                    {{itm.country}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('country_id')">
                                <div class="label-as-input">
                                    {{itm.country_id}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('equivalence_decision_date')">
                                <div class="label-as-input">
                                    {{itm.equivalence_decision_date}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('equivalence_serial_number')">
                                <div class="label-as-input">
                                    {{itm.equivalence_serial_number}}
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="auto">
                            <b-form-group :label="$t('status')">
                                <div class="label-as-input">
                                    {{itm.status}}
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </b-collapse>
        </div>
    </div>
</template>
<script>
//Template
//Component
//Other
//Service
import YoksisService from "@/services/YoksisService";
//Page


export default {
    props: {
        nationalId: {
            type: String,
            default: null
        }
    },
    components: {

    },
    data() {
        return {
            eqData: {}
        }
    },
    methods: {
        getData(nationalId){
            YoksisService.equivalenceInformation(nationalId).then(response => {
                this.eqData = response.data.data
            }).catch(e => {
                this.$toast.error(e.data.message)
            })
        }
    },

    created(){
        this.getData(this.nationalId)
    }
};
</script>

